import React from 'react';

import BooleanCheckbox from '../boolean/BooleanCheckbox';
import { useMirrorFieldsToggle } from '../../../../hooks/useMirroredFields';

/**
 * A checkbox that copies a group of source fields onto their targets while ticked, e.g. "Same as Farm
 * Address". Pair it with `conditionalDisable` on each target field so they render filled but read-only.
 *
 * Config:
 *   {
 *       name: 'use_for_mailing_address',
 *       Component: 'MirrorFieldsCheckbox',
 *       fieldMap: FARM_TO_MAILING_ADDRESS_FIELDS,
 *       props: { label: 'Same as Farm Address' },
 *   }
 *
 * It ticks itself on load when the targets already match their sources. Pass a narrower `matchFieldMap`
 * when the form pre-populates a pair with the same default on both sides, which would otherwise read as
 * a match on an empty create form.
 *
 * The toggle is presentation only — list `name` in the config's `ignoreOnSubmitFields`.
 */
function MirrorFieldsCheckbox({ name, fieldMap, matchFieldMap, props }) {
    useMirrorFieldsToggle({ name, fieldMap, matchFieldMap });

    return <BooleanCheckbox name={name} props={props} />;
}

export default MirrorFieldsCheckbox;
